import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { Marca } from "./marca";

export function EncabezadoSitio() {
  return (
    <header className="sticky top-0 z-30 border-b border-border/70 bg-background/85 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between gap-4 px-4 sm:px-6">
        <Marca />
        <nav className="flex items-center gap-1 text-sm font-medium sm:gap-2">
          <Link
            to="/posiciones"
            className="rounded-md px-3 py-2 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
            activeProps={{ className: "bg-secondary text-foreground" }}
          >
            Posiciones
          </Link>
          <Link
            to="/acceso"
            className="rounded-md px-3 py-2 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
          >
            Acceso administrativo
          </Link>
        </nav>
      </div>
    </header>
  );
}

export function PieSitio() {
  return (
    <footer className="mt-20 border-t border-border/70 bg-secondary/40">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-4 px-4 py-10 text-sm text-muted-foreground sm:px-6 md:flex-row md:items-center md:justify-between">
        <Marca />
        <p className="max-w-xl text-xs leading-relaxed">
          MEDAM protege los datos personales y documentos que recibe: se utilizan únicamente para
          fines relacionados con este proceso de selección y solo pueden ser consultados por
          personal administrativo autorizado.
        </p>
      </div>
    </footer>
  );
}

export function DisposicionSitio({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <EncabezadoSitio />
      <main className="flex-1">{children}</main>
      <PieSitio />
    </div>
  );
}
